var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconApps = function SvgIconApps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9394 6.78853C13.4457 6.78853 14.6667 5.56749 14.6667 4.06126C14.6667 2.55503 13.4457 1.33398 11.9394 1.33398C10.4332 1.33398 9.21216 2.55503 9.21216 4.06126C9.21216 5.56749 10.4332 6.78853 11.9394 6.78853Z",
    fill: "#6E6F83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06052 6.78853C5.56676 6.78853 6.7878 5.56749 6.7878 4.06126C6.7878 2.55503 5.56676 1.33398 4.06052 1.33398C2.55429 1.33398 1.33325 2.55503 1.33325 4.06126C1.33325 5.56749 2.55429 6.78853 4.06052 6.78853Z",
    fill: "#6E6F83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9394 14.6674C13.4457 14.6674 14.6667 13.4464 14.6667 11.9402C14.6667 10.4339 13.4457 9.21289 11.9394 9.21289C10.4332 9.21289 9.21216 10.4339 9.21216 11.9402C9.21216 13.4464 10.4332 14.6674 11.9394 14.6674Z",
    fill: "#6E6F83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06052 14.6674C5.56676 14.6674 6.7878 13.4464 6.7878 11.9402C6.7878 10.4339 5.56676 9.21289 4.06052 9.21289C2.55429 9.21289 1.33325 10.4339 1.33325 11.9402C1.33325 13.4464 2.55429 14.6674 4.06052 14.6674Z",
    fill: "#6E6F83"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconApps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconApps.c535dd0e.svg";
export { ForwardRef as ReactComponent };